import React from "react"
import NoteBuilder from "../NoteBuilder/NoteBuilder"

class FixNote extends React.Component {
  constructor(props) {
    super(props)
    this.touchSystemNotification = this.touchSystemNotification.bind(this)
  }

  render() {
    return(
      <NoteBuilder {...this.props}
        onSuccess={this.touchSystemNotification} />
    )
  }

  touchSystemNotification(msg) {
    var self = this;

    if (msg && top.successGrowl) {
      top.successGrowl(msg);
    }

    if (top.touchSystemNotification) {
      top.touchSystemNotification(this.props.system_notification.id);
    }
  }
}

export default FixNote